import '../index.css'

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChrome,
  faFirefox,
  faEdge,
  faSafari,
  faOpera,
  faInternetExplorer,
} from "@fortawesome/free-brands-svg-icons";

const browsers = [
  { name: "Chrome", icon: faChrome, color: "from-cyan-400 to-blue-500" },
  { name: "Firefox", icon: faFirefox, color: "from-orange-400 to-red-500" },
  { name: "Edge", icon: faEdge, color: "from-blue-400 to-indigo-500" },
  { name: "Safari", icon: faSafari, color: "from-sky-400 to-blue-300" },
  { name: "Opera", icon: faOpera, color: "from-red-500 to-pink-500" },
  { name: "IE9+", icon: faInternetExplorer, color: "from-blue-400 to-blue-700" },
];

export default function BrowserCompatibility() {
  return (
    <section className="relative bg-white py-20 bg-white bg-repeat">
      <div className="container mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-800">
            Browser Compatibility
          </h3>
          <p className="text-gray-500 mt-2">
            Works seamlessly across all modern browsers
          </p>
        </div>

        {/* Icons */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-10 justify-items-center">
          {browsers.map((b, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center transition-transform duration-300 hover:scale-110"
            >
              <div
                className={`w-24 h-24 flex items-center justify-center rounded-full bg-gradient-to-tr ${b.color} shadow-[0_0_20px_rgba(0,0,0,0.3)] relative`}
              >
                <div
                  className={`absolute inset-0 rounded-full blur-xl opacity-70 bg-gradient-to-tr ${b.color}`}
                ></div>
                <FontAwesomeIcon
                  icon={b.icon}
                  className="text-white text-5xl relative z-10 drop-shadow-lg"
                />
              </div>
              <span
                className={`mt-4 text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-tr ${b.color}`}
              >
                {b.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
